import ContentWrapper from "../../../UI/ContentWrapper/ContentWrapper";
import defaultPhoto from './defaultMaster.svg';
import MasterFreeTime from "../MasterItem/MasterFreeTime/MasterFreeTime";
import { useQuery } from "@apollo/client";
import { BOOKING_DATES, BOOKING_TIMES } from "../../../apollo/Queries";
import { apolloClientPosBranch } from "../../../apollo/ApolloClients";
import { useDispatch, useSelector } from "react-redux";
import { setEmployee } from "../../../store/employeeReducer";
import { useNavigate } from "react-router-dom";
import DateConvertToShow from "../../../utils/workingWithDateTime/DateConvertToShow";
import { useState } from "react";
import Spinner from "../../../components/Spinner/Spinner";
import { useTranslation } from "react-i18next";
import { setDate } from "../../../store/dateReducer";
import {DateTime} from "luxon";

const DefaultMaster = ({ companyId, branchId }) => {
    const { t: translate, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const timeZone = useSelector(state => state.branchReducer.timeZone);
    const currentDateISO = useSelector(state => state.dateReducer.currentDate); // ISO або null
    const dateIsEntered = useSelector(state => state.dateReducer.dateIsEntered);
    const timeIsPickedIn = useSelector(state => state.dateReducer.timeIsPickedIn);
    const pickedTime = useSelector(state => state.dateReducer.pickedTime);
    const currentService = useSelector(state => state.serviceReducer);

    const [loading, setLoading] = useState(true);
    const [defaultMasterAvailable, setDefaultMasterAvailable] = useState(false);
    const defaultEmployeeId = "-1";

    const [dateToSet, setLocalDate] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const normalizeToTZ = (value, tz) => {
        if (!value) return null;
        return DateTime.isDateTime(value)
            ? value.setZone(tz)
            : DateTime.fromISO(String(value), { setZone: true }).setZone(tz);
    };

    const { data: bookingData } = useQuery(
        BOOKING_DATES(branchId, defaultEmployeeId, currentService.serviceId, true),
        {
            client: apolloClientPosBranch,
            onCompleted: (data) => {
                const currentDT = normalizeToTZ(currentDateISO, timeZone);
                const firstISO = data?.bookingDates?.[0]?.start || null;
                const firstDT = normalizeToTZ(firstISO, timeZone);
                const fallback = DateTime.now().setZone(timeZone);

                const finalDT = currentDT || firstDT || fallback;

                setLocalDate(finalDT);
                setLoading(false);
            },
        }
    );

    const dateForRequest = dateToSet
        ? dateToSet.toFormat("yyyy-MM-dd")
        : null;

    const { data: bookingTimesData } = useQuery(
        BOOKING_TIMES(
            dateForRequest,
            branchId,
            defaultEmployeeId,
            currentService.serviceId,
            true
        ),
        {
            skip: !dateToSet,
            client: apolloClientPosBranch,
            onCompleted: (data) => {
                const endStr = data?.bookingTimes?.[0]?.end;
                if (endStr) {
                    const [hours, minutes, seconds] = endStr.split(":").map(Number);

                    const dateTimeEnd = dateToSet.set({
                        hour: hours,
                        minute: minutes,
                        second: seconds,
                        millisecond: 0,
                    });
                    setDefaultMasterAvailable(dateToSet <= dateTimeEnd);
                } else {
                    setDefaultMasterAvailable(false);
                }
                setLoading(false);
            },
            onError: (error) => {
                setLoading(false);
                console.log(error);
            },
        }
    );

    const pickEmployeeHandler = () => {
        const newEmployee = {
            employeeId: defaultEmployeeId,
            employeeName: `${translate('masterListPage.defaultMaster')}`,
            employeePhoto: defaultPhoto,
            employeePosition: null,
        };
        if (timeIsPickedIn === defaultEmployeeId) {
            const dateToUpdate = {
                currentDate: pickedTime,
                dateIsEntered: true,
            };
            dispatch(setDate(dateToUpdate));
        }

        dispatch(setEmployee(newEmployee));
        navigate(`/company/${companyId}/branch-menu-list/${branchId}`);
    };


    return (
        <>
            {(bookingTimesData && bookingTimesData.bookingTimes && bookingData.bookingDates[0].start && defaultMasterAvailable) ?
                <ContentWrapper>
                    <div className={'d-flex justify-content-between align-items-start'}>
                        <div className="d-flex align-items-center mb-3">
                            <div className={"master-photo__wrapper rounded-circle me-4"}>
                                <img src={defaultPhoto} alt="" className="rounded-5"/>
                            </div>
                            <div className={'default-master__info'}>
                                <p className="mb-0 text-secondary fs-7">{translate('branchMenuPage.master')}</p>
                                <p className="mb-0 fw-bold main_text_color">{translate('masterListPage.defaultMaster')}</p>
                            </div>
                        </div>
                            <button
                                onClick={pickEmployeeHandler}
                                className="btn btn-primary fw-bold fs-7 px-4 rounded d-none d-md-block">
                                {timeIsPickedIn === defaultEmployeeId && !dateIsEntered ?
                                    translate('masterListPage.setSpecialistAndDateTime')
                                    :
                                    translate('masterListPage.setMaster')}
                            </button>
                    </div>
                    <button
                        onClick={pickEmployeeHandler}
                        className="btn btn-primary fw-bold fs-7 w-100 mb-4 rounded d-block d-md-none">
                        {timeIsPickedIn === defaultEmployeeId && !dateIsEntered ?
                            translate('masterListPage.setSpecialistAndDateTime')
                            :
                            translate('masterListPage.setMaster')}
                    </button>
                    {!dateIsEntered &&
                        <MasterFreeTime
                            employeeId={defaultEmployeeId}
                            masterDate={
                                `${translate('masterListPage.closesTime')} ` +
                                DateConvertToShow(dateToSet, currentLanguage, timeZone)
                            }
                            closestBookingDateTimes={bookingTimesData.bookingTimes}
                            closestDate={dateToSet}
                        />}
                </ContentWrapper> :
                loading ? <Spinner/> : null}
        </>
    )
}

export default DefaultMaster